export default __webpack_public_path__ + "static/media/Transition_Back-Start.f7d1de64.mp4";